var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTabsEp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 273.67 42.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e4eef8;}.cls-3{fill:#2f71ac;}.cls-4{opacity:1;}.cls-5{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "204.8 10.22 182.44 10.22 182.44 32.57 204.8 32.57 204.8 10.22"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-tabs-ep") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-2",
    width: 273.67,
    height: 42.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "cls-1",
    x1: 273.67,
    y1: 0.36,
    x2: 0.36,
    y2: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "EP_Icon_-_Mark_Scheme",
    "data-name": "EP Icon - Mark Scheme"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec-46x46",
    className: "cls-1",
    x: 63.49,
    y: 4.38,
    width: 33.57,
    height: 33.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-3",
    d: "M80.38,8.76a12.11,12.11,0,0,1,6.26,1.69A12.62,12.62,0,0,1,91.2,15a12.39,12.39,0,0,1,0,12.51,12.49,12.49,0,0,1-21.64,0,12.44,12.44,0,0,1,0-12.51,12.62,12.62,0,0,1,4.56-4.56A12.11,12.11,0,0,1,80.38,8.76Zm0,2.42a9.8,9.8,0,0,0-5,1.36,10.25,10.25,0,0,0-3.69,3.68,10.05,10.05,0,0,0,0,10.09A10.2,10.2,0,0,0,75.34,30a10.05,10.05,0,0,0,10.09,0,10.25,10.25,0,0,0,3.68-3.69,10,10,0,0,0,0-10.09,10.3,10.3,0,0,0-3.68-3.68A9.84,9.84,0,0,0,80.38,11.18Zm7.06,6.56a.64.64,0,0,1,.21.45.49.49,0,0,1-.21.4l-8.67,8.63a.61.61,0,0,1-.46.2.46.46,0,0,1-.4-.2l-4.59-4.59a.61.61,0,0,1-.2-.45.48.48,0,0,1,.2-.41l1.16-1.16a.54.54,0,0,1,.4-.15.75.75,0,0,1,.46.15l3,3.08,7.17-7.11a.49.49,0,0,1,.4-.15.59.59,0,0,1,.45.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "EP_Icon_-_Examiner_Remarks",
    "data-name": "EP Icon - Examiner Remarks"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec-46x46-2",
    className: "cls-1",
    x: 120.41,
    y: 4.38,
    width: 33.57,
    height: 33.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-3",
    d: "M131.66,18.77a1.69,1.69,0,1,0,1.69,1.69h0a1.69,1.69,0,0,0-1.69-1.69h0m5.9,0a1.69,1.69,0,1,0,1.69,1.69h0a1.68,1.68,0,0,0-1.68-1.69h0m5.91,0a1.69,1.69,0,1,0,1.69,1.69h0a1.69,1.69,0,0,0-1.69-1.69h0m-15.3,11.36A13,13,0,0,0,129.22,28l.56-1.49-1.08-1.15a7.21,7.21,0,0,1-2.1-4.93c0-4.65,4.92-8.43,11-8.43s11,3.78,11,8.43-4.91,8.44-11,8.44a13.51,13.51,0,0,1-4.14-.64l-1.2-.38-1,.73a11.13,11.13,0,0,1-3,1.53m9.4-20.64c-7.46,0-13.5,4.91-13.5,11a9.61,9.61,0,0,0,2.79,6.66A13.32,13.32,0,0,1,124.41,31a1.26,1.26,0,0,0,0,1.79,1.23,1.23,0,0,0,.87.35,12.84,12.84,0,0,0,7.34-2.44,16.21,16.21,0,0,0,4.89.75c7.46,0,13.51-4.91,13.51-11s-6-11-13.51-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "EP_icon_-_Resources",
    "data-name": "EP icon - Resources",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec-46x46-3",
    className: "cls-1",
    x: 232.8,
    y: 4.38,
    width: 33.57,
    height: 33.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paperclip",
    "data-name": "Icon awesome-paperclip",
    className: "cls-3",
    d: "M241.27,30.2a6.58,6.58,0,0,1,0-9.31l0,0,9.24-9.19a5,5,0,0,1,7.09,0,4.88,4.88,0,0,1,0,6.91l0,0-8.06,8a3.36,3.36,0,0,1-4.75,0h0a3.26,3.26,0,0,1,.07-4.59l6.34-6.29a.71.71,0,0,1,1,0l1,1a.67.67,0,0,1,0,.95l0,0-6.34,6.29a.57.57,0,0,0,0,.79.47.47,0,0,0,.67,0l0,0,8.06-8a2.2,2.2,0,0,0,0-3.11h0a2.16,2.16,0,0,0-3.05,0l-9.25,9.2a3.9,3.9,0,0,0,0,5.5,3.84,3.84,0,0,0,5.42,0h0l7.59-7.54a.71.71,0,0,1,1,0l1,1a.67.67,0,0,1,0,.95l0,0-7.59,7.54A6.71,6.71,0,0,1,241.27,30.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "EP_Icon_-_Question",
    "data-name": "EP Icon - Question"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec-46x46-4",
    className: "cls-1",
    x: 7.3,
    y: 4.38,
    width: 33.57,
    height: 33.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-3",
    d: "M31.64,32.93a1.62,1.62,0,0,1-1.05.53A1.41,1.41,0,0,1,29.43,33l-1.67-1.57a7.31,7.31,0,0,1-2,.88,9.68,9.68,0,0,1-2.57.32,8.64,8.64,0,0,1-3.72-.72A6.54,6.54,0,0,1,17.06,30a7.1,7.1,0,0,1-1.33-2.68,11.55,11.55,0,0,1-.4-3.09V17.84a11.16,11.16,0,0,1,.17-2.08,9,9,0,0,1,.56-2,7.47,7.47,0,0,1,1-1.71,6.07,6.07,0,0,1,1.49-1.37,7.26,7.26,0,0,1,2-.91,10.93,10.93,0,0,1,5.27,0,7.26,7.26,0,0,1,2.05.91,6.07,6.07,0,0,1,1.49,1.37,7.16,7.16,0,0,1,1,1.71,8.46,8.46,0,0,1,.57,2,12.08,12.08,0,0,1,.17,2.08v6.39a10.94,10.94,0,0,1-.29,2.61,7.72,7.72,0,0,1-.94,2.35l1.69,1.52a1.59,1.59,0,0,1,.41.55,1.23,1.23,0,0,1,.12.59,1.43,1.43,0,0,1-.12.58A1.61,1.61,0,0,1,31.64,32.93Zm-4-15.09a9.28,9.28,0,0,0-.22-2,4.25,4.25,0,0,0-.71-1.63,3.5,3.5,0,0,0-1.36-1.08,5.93,5.93,0,0,0-4.23,0,3.32,3.32,0,0,0-1.34,1.07,4.14,4.14,0,0,0-.7,1.63,10.12,10.12,0,0,0-.21,2.05v6.39a10,10,0,0,0,.21,2,4.47,4.47,0,0,0,.72,1.64A3.28,3.28,0,0,0,21.1,29a4.9,4.9,0,0,0,2.1.39,3.64,3.64,0,0,0,2.06-.51l-.7-.65a1.09,1.09,0,0,1-.29-.44,1.24,1.24,0,0,1-.07-.51,1.28,1.28,0,0,1,.13-.5,1.6,1.6,0,0,1,1.12-.92.91.91,0,0,1,.85.2l.74.59a3.39,3.39,0,0,0,.44-1.1,6.42,6.42,0,0,0,.12-1.32Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "EP_Icon_-_Notes",
    "data-name": "EP Icon - Notes"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rec-46x46-5",
    className: "cls-1",
    x: 176.61,
    y: 4.38,
    width: 33.57,
    height: 33.57
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-3",
    d: "M204.8,26a2.36,2.36,0,0,1-.7,1.7l-4.19,4.19a2.32,2.32,0,0,1-1.7.7H184.84a2.39,2.39,0,0,1-2.4-2.37V12.61a2.39,2.39,0,0,1,2.38-2.39H202.4a2.38,2.38,0,0,1,2.4,2.37V26Zm-2.4-13.37H184.84V30.18H196V25a1.19,1.19,0,0,1,1.19-1.2h5.2Zm-4,17.36,3.79-3.79h-3.79Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTabsEp);
export default __webpack_public_path__ + "static/media/ico-tabs-ep.3c38655e2ba70c34ca465c04d6cf5c47.svg";
export { ForwardRef as ReactComponent };